import Vue from 'vue'
import { RUN_USER_LOGIN,RUN_USER_LOGOUT,RUN_STATE_LOAD,GET_TOKEN,SET_STATE,SET_STATE_PERSIST_LOCAL,SET_TOGGLE_LOADER,SET_INFO,GET_USER} from '../types'
import * as RxFactory from './api/rx-factory'
import * as types from '@/types'
export const EP_ADMIN_LOGIN 			= 				'/admin/api/login'
export const EP_ADMIN_LOGOUT 			= 				'/signout'
export const BASE_URL 					= 				 process.env.LOCAL_FACADE_SERVER_FULL_ADDRESS_ADMIN


export const actions = {
  	[RUN_USER_LOGIN]({commit, state, dispatch,getters}, credentials){
  		try{
  			const parameter = credentials.parameter
  			delete credentials.parameter
  			const router = credentials.router
			delete credentials.router
			parameter.pageLoader = true
  			RxFactory.post(BASE_URL + EP_ADMIN_LOGIN, credentials)
				.map(response => response.data)
				.subscribe(data => {parameter.pageLoader = false
					if ('info' in data) {
						if (data.info === 'OK') {
							data.data.user.loggedIn = true
							let role_array = data.data.user.roles.split('&')
							data.data.user.roles = role_array
							
							commit(SET_STATE, data.data.user)
							localStorage.setItem('user', btoa(JSON.stringify(data.data.user)))

							if(data.data.user.roles.length > 0 && data.data.user.roles.indexOf('SSU') != -1){
								router.replace('/squadiq-user-list'); 
							}else{
								if(data.data.user.route_roles=="IKF_USER"){
									router.push('/subscriptions');
								}
								else{
									router.push('/Users/dashboard');
								}
							}
							
						}
						else{
							parameter.$notify({
								group: 'foo',
								text: 'Invalid Credentials',
								type: 'error'
			                }); 
						}
					}
				},
				e => {
					_handleErrorResponse(e, commit)
				}
			)
		} catch (ex) {
			_handleErrorResponse(ex, commit)
		}
  	},
	[RUN_USER_LOGOUT]({commit, state, getters}, getdata) {
		RxFactory.get(BASE_URL + EP_ADMIN_LOGOUT, {'Authorization': 'Bearer ' + getters[GET_TOKEN]})
		.map(response => response.data)
		.subscribe(data => {
				_handleLogout(data, commit, {router: getdata.router, forward:true})
			},
			(e, d, s) => {
				_handleLogout(e, commit, {router: getdata.router, forward:true})
			}
		)
	},
	[RUN_STATE_LOAD] ({commit, dispatch, state, getters},getdata) {
		const data = {}
		let user = localStorage.getItem('user')
		if (user) {
			user = atob(user) 
			user = JSON.parse(user)
		}
		if((user == null || user == '') && location.pathname !== '/'){
			window.location.href = "/"
		}
		else{
			commit(SET_STATE, user)
			if(user !== null && user !==''){
				
				RxFactory.post(BASE_URL + "/get/fresh/user/data", {}  , {'Authorization': 'Bearer ' + getters[GET_TOKEN]})
					.map(response => response.data)
					.subscribe(data => {
						if ('info' in data) {
							if (data.info === 'OK') {
								let path = ""
								data.data.user.loggedIn = true
								
								commit(SET_STATE, data.data.user)
								localStorage.setItem('user', btoa(JSON.stringify(data.data.user)))
							}
						}
					},
					e => {					
						_handleErrorResponse(e, commit)
					}
				)
			}
		}
	}
	// [RUN_STATE_LOAD] ({commit, dispatch, state}) {
		
	// 	if((user == null || user == '') && location.pathname !== '/'){
	// 		window.location.href = "/"
	// 	}
	// 	commit(SET_STATE, user)
	// }
}

//------------------------------------------------functions----------------------------------------------------------------------
function _cleanUp (commit, msg, status, loaderId) {
  let loaderArr = (typeof loaderId !== 'undefined') ? [loaderId] : []
  commit(SET_TOGGLE_LOADER, loaderArr)
  commit(SET_INFO, msg)
}

function _handleErrorResponse (e, commit) {
    let response = {info: 'NOK', msg: 'Service not available'}
	if (typeof e.response === 'undefined') {
		try {
			const statusCheck = e.toString().toLowerCase()
			if (statusCheck.indexOf('network') > -1) {
			response = {info: 'NOK', msg: 'Network Error'}
			}
		} catch(e){}
	}else{
		if(e.response.status == '401'){
			window.location.href = "/";
		}
		response = e.response.data
	}
	_cleanUp(commit, response, response.status)
}

function _handleLogout (data, commit,options,getters) {
	const router = options.router
	let user = {
		active: 0,
		country: '',
		created: '',
		email: '',
		profile: {
			firstname: '',
			lastname: '',
			pid: '',
			cid: ''
		},
		roles: '',
		token: false,
		username: '',
		loggedIn: false
	}
	
	commit(SET_STATE, user)
	commit(SET_STATE_PERSIST_LOCAL)
	localStorage.clear()
	if ( 'msg' in data && 'info' in data) {
		_cleanUp(commit, data.msg, data.info)
	}
	if (options.forward === true) {
		router.replace('/')
		location.reload();
	}
}




// WEBPACK FOOTER //
// ./src/store/actions.js